var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 661 600"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 55",
    d: "M532.2 49.431S503.672 0 446.627 0H214.373S157.326 0 128.8 49.431L12.677 250.608s-28.524 49.405 0 98.811L128.8 550.595S157.326 600 214.373 600h232.254s57.045 0 85.569-49.405l116.127-201.177s28.524-49.405 0-98.811z",
    fill: "currentColor"
  })));
}
export default SvgHexagonSolid;